import { createApp } from "vue"
import { createRouter, createWebHistory } from 'vue-router'

import BannerComponent from "./components/BannerComponent.vue";
import NavigationComponent from "./components/NavigationComponent.vue";
import SubBanner from "./components/SubBanner.vue";
import FeaturedPartners from "./components/FeaturedPartners.vue";
import FeaturedGalleries from "./components/FeaturedGalleries.vue";
import DatabaseItem from "./components/DatabaseItem.vue";
import PartnersPage from "./components/PartnersPage.vue";
import PartnerProfile from "./components/PartnerProfile.vue";
import PartnerObjects from "./components/PartnerObjects.vue";
import GalleriesPage from "./components/GalleriesPage.vue";
import AboutPage from "./components/AboutPage.vue";
import CreditsPage from "./components/CreditsPage.vue";
import ErrorPage from "./components/ErrorPage.vue";

// Vue.use(VueRouter);

const routes = [
  { 
    path: "/",
    name: "home",
    components: {
      "banner": BannerComponent,
      "navigation": NavigationComponent,
      "featured-partners": FeaturedPartners,
      "featured-galleries": FeaturedGalleries
    }
  },
  { 
    path: "/list/:page?",
    name: "list",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: GalleriesPage
    }
  },
  {
    // path: "/database-item/:pathMatch(.*)*/:language",
    path: "/database-item/:project/:country/:id/:object/:language",
    name: "database-item",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: DatabaseItem
    }
  },
  {
    path: "/partners",
    name: "partners",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: PartnersPage
    }
  },
  {
    path: "/partner/:database/:country/:id/:language",
    name: "partner",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: PartnerProfile
    }
  },
  {
    path: "/partner-objects/:database/:country/:id/:page",
    name: "partner-objects",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: PartnerObjects
    }
  },
  {
    path: "/about",
    name: "about",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: AboutPage
    }
  },
  {
    path: "/credits",
    name: "credits",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: CreditsPage
    }
  },
  {
    path: "/error",
    name: "error",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: ErrorPage
    }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_ROUTE),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to);
    if (to.hash) {
      setTimeout(() => {
        const element = document.getElementById(to.hash.replace(/#/, ""))
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }, 1000);
      return { el: to.hash, behavior: 'smooth', };
    } else if (!to.path.includes("chronology") && savedPosition) {
      return savedPosition;
    } else {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
});

export default router;